/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Today_Exercises_LabelInputs */

const en_us2_today_exercises_label = /** @type {(inputs: Today_Exercises_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Today's exercises`)
};

const pt_br2_today_exercises_label = /** @type {(inputs: Today_Exercises_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercícios de hoje`)
};

const es_419_today_exercises_label = /** @type {(inputs: Today_Exercises_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ejercicios de hoy`)
};

const pt_pt2_today_exercises_label = /** @type {(inputs: Today_Exercises_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercícios de hoje`)
};

const fr_fr2_today_exercises_label = /** @type {(inputs: Today_Exercises_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercices du jour`)
};

const de_de2_today_exercises_label = /** @type {(inputs: Today_Exercises_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heutige Übungen`)
};

const it_it2_today_exercises_label = /** @type {(inputs: Today_Exercises_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esercizi di oggi`)
};

/**
* | output |
* | --- |
* | "Today's exercises" |
*
* @param {Today_Exercises_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_exercises_label = /** @type {((inputs?: Today_Exercises_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_Exercises_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_exercises_label(inputs)
	if (locale === "es-419") return es_419_today_exercises_label(inputs)
	if (locale === "pt-PT") return pt_pt2_today_exercises_label(inputs)
	if (locale === "fr-FR") return fr_fr2_today_exercises_label(inputs)
	if (locale === "de-DE") return de_de2_today_exercises_label(inputs)
	if (locale === "it-IT") return it_it2_today_exercises_label(inputs)
	return en_us2_today_exercises_label(inputs)
});
export { today_exercises_label as "today.exercises_label" }